import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AmendDialogComponent} from './amend-dialog.component';
import {DropdownModule} from '../dropdown/dropdown.module';
import {InputModule} from '../input/input.module';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '../dialog/dialog.module';
import {ButtonModule} from '../button/button.module';
import {AlertModule} from '../alert/alert.module';
import {FormattedDateModule} from '../../pipes/formatted-date/formatted-date.module';
import {FormattedDatePipe} from '../../pipes/formatted-date/formatted-date.pipe';
import {AbsoluteValueModule} from '../../pipes/absolute-value/absolute-value.module';
import {AbsoluteValuePipe} from '../../pipes/absolute-value/absolute-value.pipe';
import { DatepickerInputModule } from '../datepicker-input/datepicker-input.module';
import { RxNumberModule } from '../../pipes/rx-number/rx-number.module';
import { TransactionBadgeModule } from '../../pipes/transaction-badge/transaction-badge.module';
import { YesNoToggleModule } from '../yes-no-toggle/yes-no-toggle.module';
import { BackCountNotResolvedTooltipModule } from '../back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';
import { CompoundAmendTableComponent } from './compound-amend-table/compound-amend-table.component';
import { GenericTableModule } from '../generic-table/generic-table.module';
import { GenericWriteTableModule } from '../generic-write-table/genetic-write-table.module';


@NgModule({
  declarations: [
    AmendDialogComponent,
    CompoundAmendTableComponent,
  ],
  imports: [
    CommonModule,
    DropdownModule,
    InputModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    AlertModule,
    FormattedDateModule,
    AbsoluteValueModule,
    DatepickerInputModule,
    RxNumberModule,
    TransactionBadgeModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule,
    GenericWriteTableModule
  ],
  providers: [
    FormattedDatePipe,
    AbsoluteValuePipe
  ],
  exports: [
    AmendDialogComponent,
  ],
})
export class AmendDialogModule {
}
